import { Component, OnInit, OnChanges, Input, ViewChild, TemplateRef } from '@angular/core';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { ToasterService } from 'angular2-toaster';
import { TelecallerTempAssignService } from '../../../services/telecallerTempAssign.service';
import * as _ from 'lodash';

declare var swal: any;

@Component({
    selector: 'telecaller-temp-assign-tab',
    templateUrl: './telecallerTempAssign.component.html',
    styleUrls: ['./telecallerTempAssign.component.css']
})
export class TelecallerTempAssignComponent implements OnInit, OnChanges {
    private initialized = false;
    @Input('tabTitle') title = 'Temporary Call Assignment';
    @Input() active = false;
    @Input() dataContext: any = {};

    @ViewChild('ttaTable') ttaTable: any;
    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('fromUserTemplate') fromUserTemplate: TemplateRef<any>;
    @ViewChild('toUserTemplate') toUserTemplate: TemplateRef<any>;
    @ViewChild('pendingDoneTemplate') pendingDoneTemplate: TemplateRef<any>;
    @ViewChild('statusTemplate') statusTemplate: TemplateRef<any>;
    @ViewChild('actionTemplate') actionTemplate: TemplateRef<any>;

    columns = [];
    rows: any[] = [];
    isLoadMask: Promise<any>;
    loadingIndicator = true;
    reorderable = true;

    filterExpanded = false;
    filterData = { search_data: '', status: '' };

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'id',
        orderDir: 'desc'
    };

    telecallerList: any[] = [];
    allUserList: any[] = [];

    modalRef: BsModalRef;
    modalData: any = {};
    modalLoading = false;
    previewCount: number = null;
    previewLoaded = false;

    revokeModalRef: BsModalRef;
    revokeItem: any = null;
    revokeLoading = false;

    constructor(
        private svc: TelecallerTempAssignService,
        private modalService: BsModalService,
        private toasterService: ToasterService
    ) { }

    ngOnInit() {
        this.columns = [
            { name: 'SNo', prop: 'id', width: 55, minWidth: 55, maxWidth: 55, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'From User (On Leave)', prop: 'from_user_name', width: 180, minWidth: 180, cellTemplate: this.fromUserTemplate },
            { name: 'To User (Covering)', prop: 'to_user_name', width: 160, minWidth: 160, cellTemplate: this.toUserTemplate },
            { name: 'Assigned Date', prop: 'addedon', width: 110, minWidth: 110, maxWidth: 110 },
            { name: 'Records', prop: 'total_records', width: 80, minWidth: 80, maxWidth: 80, cellClass: 'cell-center' },
            { name: 'Reason', prop: 'reason', width: 180, minWidth: 180 },
            { name: 'Pending / Done', prop: 'pending_count', width: 160, minWidth: 160, maxWidth: 160, sortable: false, cellTemplate: this.pendingDoneTemplate },
            { name: 'Status', prop: 'status', width: 110, minWidth: 110, maxWidth: 110, cellTemplate: this.statusTemplate },
            { name: 'Action', prop: 'id', width: 90, minWidth: 90, maxWidth: 90, sortable: false, cellClass: 'cell-center', cellTemplate: this.actionTemplate }
        ];
        this.initialized = true;
        if (this.active) {
            this.loadList();
        }
    }

    ngOnChanges() {
        if (this.initialized && this.active) {
            this.loadList();
        }
    }

    applyFilter() {
        this.page.offset = 0;
        this.loadList();
    }

    clearFilter() {
        this.filterData = { search_data: '', status: '' };
        this.applyFilter();
    }

    loadList() {
        this.loadingIndicator = true;
        this.isLoadMask = this.svc.getList({
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`,
            search_data: this.filterData.search_data,
            status: this.filterData.status
        }).then(res => {
            this.loadingIndicator = false;
            if (res && res.success) {
                this.rows = res.data || [];
                this.page.count = res.totCnt || this.rows.length;
            }
        }).catch(() => { this.loadingIndicator = false; });
    }

    pageCallback(pageInfo: { page?: number }) {
        if (!pageInfo.page) return;
        const newOffset = pageInfo.page - 1;
        if (newOffset === this.page.offset) return;
        this.page.offset = newOffset;
        this.loadList();
    }

    sortCallback(sortInfo: { sorts: { dir: string, prop: string }[] }) {
        this.page.orderBy  = sortInfo.sorts[0].prop;
        this.page.orderDir = sortInfo.sorts[0].dir;
        this.loadList();
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.loadList();
    }

    openNewModal(tpl: TemplateRef<any>) {
        this.modalData = { from_user_id: '', to_user_id: '', reason: '' };
        this.previewCount = null;
        this.previewLoaded = false;
        this.modalLoading = false;

        this.svc.getTelecallerList({}).then(res => {
            this.telecallerList = res && res.success ? res.data : [];
        });
        this.svc.getAllFollowupUserList({}).then(res => {
            this.allUserList = res && res.success ? res.data : [];
        });

        this.modalRef = this.modalService.show(tpl, { class: 'modal-lg', ignoreBackdropClick: true });
    }

    getSelectedFromUser(): any {
        return this.telecallerList.find(u => u.userid == this.modalData.from_user_id) || null;
    }

    getSelectedToUser(): any {
        return this.allUserList.find(u => u.userid == this.modalData.to_user_id) || null;
    }

    getUserLabel(u: any): string {
        if (!u) return '';
        return (u.telecaller_slot ? u.telecaller_slot + ' — ' : '') + u.fullname;
    }

    onFromUserChange() {
        this.previewCount = null;
        this.previewLoaded = false;
        if (!this.modalData.from_user_id) return;
        this.svc.getPreviewCount({ from_user_id: this.modalData.from_user_id }).then(res => {
            if (res && res.success) {
                this.previewCount = res.total;
                this.previewLoaded = true;
            }
        });
    }

    confirmCreate() {
        if (!this.modalData.from_user_id) {
            this.pop('warning', 'Please select From User (On Leave)'); return;
        }
        if (!this.modalData.to_user_id) {
            this.pop('warning', 'Please select To User (Covering)'); return;
        }
        if (this.modalData.from_user_id == this.modalData.to_user_id) {
            this.pop('warning', 'From User and To User cannot be the same'); return;
        }
        this.modalLoading = true;
        this.svc.create(this.modalData).then(res => {
            this.modalLoading = false;
            if (res && res.success) {
                this.pop('success', res.message || 'Temporary assignment created');
                this.modalRef.hide();
                this.loadList();
            } else {
                this.pop('error', res && res.message ? res.message : 'Error creating assignment');
            }
        }).catch(() => {
            this.modalLoading = false;
            this.pop('error', 'Server error');
        });
    }

    openRevokeModal(tpl: TemplateRef<any>, item: any) {
        this.revokeItem = item;
        this.revokeLoading = false;
        this.revokeModalRef = this.modalService.show(tpl, { class: 'modal-sm', ignoreBackdropClick: true });
    }

    confirmRevoke() {
        if (!this.revokeItem) return;
        this.revokeLoading = true;
        this.svc.revoke({ id: this.revokeItem.id }).then(res => {
            this.revokeLoading = false;
            if (res && res.success) {
                this.pop('success', res.message || 'Assignment revoked');
                this.revokeModalRef.hide();
                this.loadList();
            } else {
                this.pop('error', res && res.message ? res.message : 'Error revoking');
            }
        }).catch(() => {
            this.revokeLoading = false;
            this.pop('error', 'Server error');
        });
    }

    getFromUserName(item: any): string {
        const slot = item.from_user_slot ? item.from_user_slot : '';
        return slot ? slot + ' — ' + item.from_user_name : item.from_user_name;
    }

    getToUserName(item: any): string {
        return item.to_user_name || '';
    }

    private pop(type: string, msg: string) {
        let toast: any = { type, title: type === 'success' ? 'Success' : (type === 'error' ? 'Error' : 'Warning'), body: msg };
        this.toasterService.pop(toast);
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/telecallerTempAssign/telecallerTempAssign.component.ts